import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @Input() type: 'primary' | 'secondary' | 'error' | 'standard' | 'error-light' | 'error-transparent';

  @Input() label: string;

  @Input() disabled: boolean;

  @Input() disabledStyle: 'primary' | 'secondary' = 'primary';

  @Input() size: 'standard' | 'large' = 'standard';

  @Output() onClick = new EventEmitter<void>();

  public buttonClicked(): void {
    this.onClick.emit();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/button/button.component.ts